import { Injectable, Inject } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class RootRedirectGuard implements CanActivate {
  private readonly defaultLang = 'es-mx';

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private doc: Document,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const url = state.url || '/';
    const pathOnly = (url.split('?')[0] || '').split('#')[0];
    const { search, hash } = this.doc.location;
    const authPattern = /(code|state|client_info|id_token|access_token|error)=/;
    const hasAuthParams = authPattern.test(search) || authPattern.test(hash) || authPattern.test(url);
    const isAuthRoute = url.startsWith('/login') || url.startsWith('/redirect');
    if (hasAuthParams || isAuthRoute) {
      return true;
    }
    // Only prefix language for the root URL; leave other routes untouched
    if (pathOnly === '/' || pathOnly === '') {
      // Detectar idioma del navegador
      const allowed = ['es-mx', 'en-us'];
      const browserLang =
        navigator.languages && navigator.languages.length > 0
          ? navigator.languages[0].toLowerCase()
          : (navigator.language || '').toLowerCase();
      let matchedLang = allowed.find((lang) => browserLang === lang);
      if (!matchedLang) {
        const browserLangPrefix = browserLang.split('-')[0];
        if (browserLangPrefix === 'en' && allowed.includes('en-us')) {
          matchedLang = 'en-us';
        } else if (browserLangPrefix === 'es' && allowed.includes('es-mx')) {
          matchedLang = 'es-mx';
        } else {
          matchedLang = allowed.find((lang) => lang.startsWith(browserLangPrefix));
        }
      }
      const redirectLang = matchedLang || this.defaultLang;
      return this.router.createUrlTree([`/${redirectLang}`], {
        queryParams: route.queryParams,
        fragment: route.fragment || undefined,
      });
    }
    return true;
  }
}
